<div class="root">
  <div class="title">{{ 'Enable Push notifications ?' | translate }}</div>

  <p>{{ 'Push text' | translate }}</p>
  @if (error) {
    <p class="error-text">{{ error }}</p>
  }
  <div class="actions">
    <button mat-button [disabled]="(working$ | async) || error" (click)="enablePush()">
      {{ (working$ | async) ? ('Working' | translate) : ('Allow' | translate) }}
    </button>
    <button mat-button [disabled]="working$ | async" (click)="dismiss()">{{ 'No, thanks' | translate }}</button>
  </div>
</div>
